import { createStore } from 'vuex'

// Vue.use(Vuex)

// ↓----- Vuex Store Settings ---------------------------------------------------------------
// --------------------------------------------------------------
// State: 値の保管庫
// --------------------------------------------------------------
const state = {
  // ログイン関連
  login: {
    user_id: null,
    profile: {},
    customer: {}
  },
  // ui表示関係全般
  ui: {
    loading: false, // ローダー
    toolbarElevation: false, // ツールバー立体化
    firstToolbarHide: false, // 1番目のツールバーを隠す
    leftDrawer: false, // 左メニュー
    rightDrawer: false, // 右メニュー
    googleApiLoaded: false // whether google API is loaded or not
  },
  // グローバルアラート（どのコンポーネントからも呼び出せて表示）
  alert: {
    show: false,
    title: null,
    body: null,
    pre: false
  },
  // ページ戻るリンク特別指定
  location: {
    backLink: null
  },
  notification: {
    show: false,
    message: null,
    time: 5000,
    styles: {
      position: 'top',
      alignment: 'center',
      textColor: 'black--text',
      color: 'yellow'
    }
  },
  // エラーレスポンス
  errorRes: {}
}

// --------------------------------------------------------------
// Getter: Stateに保存されている値をコンポーネントへ表示
// --------------------------------------------------------------
const getters = {
  login: state => state.login,
  ui: state => state.ui,
  alert: state => state.alert,
  location: state => state.location,
  errorRes: state => state.errorRes,
  notification: state => state.notification
  // form: state => state.form,
}

// --------------------------------------------------------------
// Mutation: Stateの変更操作
// --------------------------------------------------------------
const mutations = {
  login (state, obj) {
    for (const key of Object.keys(obj)) {
      state.login[key] = obj[key]
    }
  },
  ui (state, obj) {
    for (const key of Object.keys(obj)) {
      state.ui[key] = obj[key]
    }
  },
  alert (state, content) {
    state.alert.show = true
    state.alert.title = content.title
    state.alert.body = content.body
    state.alert.pre = content.pre
  },
  hide_alert (state) {
    state.alert.show = false
    setTimeout(() => {
      state.alert.title = null
      state.alert.body = null
    }, 500)
  },
  clearErrorRes (state) {
    state.errorRes = {}
  },
  errorRes (state, obj) {
    for (const key of Object.keys(obj)) {
      state.errorRes[key] = obj[key]
    }
  },
  triggerNotification (state, content) {
    state.notification.show = true
    state.notification.message = content.message
    state.notification.time = content.time || state.notification.time

    state.notification.styles.color = content.color || state.notification.styles.color
    state.notification.styles.position = content.position || state.notification.styles.position
    state.notification.styles.alignment = content.alignment || state.notification.styles.alignment
    state.notification.styles.textColor = content.textColor || state.notification.styles.textColor
  }
}

// --------------------------------------------------------------
// Action: Componentや外部APIからの入出力を受け付ける
// --------------------------------------------------------------
const actions = {
  login ({ commit }, obj) { commit('login', obj) },
  ui ({ commit }, obj) { commit('ui', obj) },
  alert ({ commit }, content) { commit('alert', content) },
  hide_alert ({ commit }) { commit('hide_alert') },
  clearErrorRes ({ commit }) { commit('clearErrorRes') },
  errorRes ({ commit }, obj) { commit('errorRes', obj) },
  triggerNotification ({ commit }, content) { commit('triggerNotification', content) }
}

// ↑----- Vuex Store Settings ---------------------------------------------------------------

export default createStore({
  state,
  getters,
  actions,
  mutations
})
